import api from './api';

const demandasService = {
  list(params = {}) {
    return api.get('/demandas', { params });
  },
  create(data) {
    return api.post('/demandas', data);
  },
  update(id, data) {
    return api.put(`/demandas/${id}`, data);
  },
  updateStatus(id, status) {
    return api.patch(`/demandas/${id}/status`, { status });
  },
  remove(id) {
    return api.delete(`/demandas/${id}`);
  }
};

export default demandasService;